const ContactTypes = () => (
  <div>
        <p><strong>Master user</strong> - <i>Can add and remove a User or Master User at your company or make any other changes</i></p>
        <p><strong>Trader</strong> – <i>Access to trade and view all</i></p>
        <p><strong>Trade Settlement Manager</strong> – <i>View only</i></p>
        <p><strong>Alternative Trade Settlement Contact</strong> – <i>View only</i></p>
        <p><strong>Credit department contact</strong> – <i>View only</i></p>
        <p><strong>Alternative credit department contact</strong> – <i>View only</i></p>
        <p><strong>Viewer only</strong></p>
  </div>
);

export default ContactTypes;



// WEBPACK FOOTER //
// ./source/screens/static/ContactTypes.js